module.exports = __webpack_public_path__ + "img/zl_logo.e2a590a5.png";